import * as Bixby from '$/core';

export abstract class SettingsService {
  public static async getAll(): Promise<Bixby.Models.Settings> {
    const route = Bixby.API.ServerRoute.forAction(Bixby.Constants.API_SETTINGSCONTROLLER);
    return await Bixby.API.get(route);
  }

  public static async updateSettings(command: Bixby.Models.Settings): Promise<Bixby.Models.Settings> {
    const route = Bixby.API.ServerRoute.forAction(
      `${Bixby.Constants.API_ADMIN_PREFIX}/${Bixby.Constants.API_SETTINGSCONTROLLER}`
    );
    return await Bixby.API.put(route, command);
  }
}
